import { createSelector } from 'reselect';
import { setAlpha } from 'web-common/scripts/utils/color';

export const rgbToAlfa = createSelector(
    (rgb) => rgb,
    (_, alfa) => alfa,
    (rgb, alfa) => setAlpha(rgb, alfa)
);
